import apiClient from "../../api/trackerApiClient";


/**
 * Payload used to start the web tracker session.
 * @typedef {Object} StartWebTrackerPayload
 * @property {string} username - User email.
 * @property {number|string} userID - User unique identifier.
 * @property {number|string} projectID - Project identifier.
 * @property {string} startTime - Start time in format YYYY-MM-DD HH:mm:ss.
 */
/**
 * Starts a new web tracker session.
 *
 * @param {StartWebTrackerPayload} payload - Tracker start payload.
 * @returns {Promise<Object>} API response data.
 */
export const startWebTrackerRequest = async(payload) => {
    const startWebTrackerResponse = await apiClient.post(import.meta.env.VITE_POST_START_WEBTRACKER, payload)


    return startWebTrackerResponse.data
}

/**
 * Session data used to stop the web tracker session.
 * @typedef {Object} StopWebTrackerSessionData
 * @property {string} sessionId - Tracker session identifier.
 * @property {string} endTime - End time in format YYYY-MM-DD HH:mm:ss.
 */
/**
 * Stops an active web tracker session. 
 *
 * @param {StopWebTrackerSessionData} sessionData - Tracker session data.
 * @returns {Promise<Object>} API response data.
 */
export const stopWebTrackerRequest = async(sessionData) => {
    const stopWebTrackerRequest = await apiClient.post(import.meta.env.VITE_POST_STOP_WEBTRACKER, sessionData)

    return stopWebTrackerRequest.data
}

/**
 * Logs tracker online status.
 *
 * @param {number|string} userId - User identifier.
 * @returns {Promise<Object>} API response data.
 */
export const logTrackerStatusRequest = async(userId) => {
    const params = {
        userID: userId
    }
    const logTrackerStatusResponse = await apiClient.post(import.meta.env.VITE_TRACKER_ONLINE, null, { params })

    return logTrackerStatusResponse.data
}

/**
 * Updates tracker online/offline status.
 *
 * @param {number|string} userId - User identifier.
 * @param {boolean} online - Tracker online status.
 * @returns {Promise<Object>} API response data.
 */
export const updateLogTrackerStatusRequest = async(userId, online) => {
    const params = {
        ID: userId,
        Online: online
    }
    const updateLogTrackerStatusResponse = await apiClient.put(import.meta.env.VITE_TRACKER_ONLINE, null, { params })
    
    return updateLogTrackerStatusResponse.data
}

export const getUserSpecsRequest = async(userId) => {
    const params = {
        userID: userId
    }
    const response = await apiClient.get('/compliance/specs', { params })

    return response.data
}

export const getWebTrackerStatus = async(username) => {
    const respnse = await apiClient.get(`Tracker/webtracker/Status?username=${username}`)

    return respnse.data
}